const BodyReportHeroSection = () => {
  const handleReservation = () => {
    const element = document.querySelector('#reservation');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleLineContact = () => {
    window.open('https://line.me/R/ti/p/@luciall', '_blank');
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-white via-light-gold/30 to-white">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle, #C9A961 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }}></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 py-20 md:py-32">
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center">
          {/* Left Content */}
          <div className="text-center md:text-left">
            <div className="inline-block bg-gold/10 border border-gold/30 rounded-full px-6 py-2 mb-6">
              <p className="text-gold text-sm font-semibold tracking-widest">BODY REPORT</p>
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-dark-gray mb-6 leading-tight">
              波動測定で<br />
              <span className="text-gold">未病を見つける</span>
            </h1>
            
            <p className="text-lg md:text-xl text-dark-gray/80 mb-8 leading-relaxed">
              身体の周波数の乱れを測定し、<br className="hidden md:block" />
              健康状態を可視化するシステム
            </p>

            <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 mb-8">
              <h3 className="text-xl font-bold text-dark-gray mb-4 flex items-center">
                <i className="ri-checkbox-circle-fill text-gold text-2xl mr-3"></i>
                こんな方におすすめ
              </h3>
              <ul className="space-y-3 text-dark-gray/80">
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-fill text-gold text-xl mr-2 mt-0.5"></i>
                  <span>最近、疲れやすくなった</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-fill text-gold text-xl mr-2 mt-0.5"></i>
                  <span>とにかく身体が重い</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-fill text-gold text-xl mr-2 mt-0.5"></i>
                  <span>寝つき、目覚めが悪い</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-fill text-gold text-xl mr-2 mt-0.5"></i>
                  <span>集中力が続かない</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-fill text-gold text-xl mr-2 mt-0.5"></i>
                  <span>精神的に不安定</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-fill text-gold text-xl mr-2 mt-0.5"></i>
                  <span>病院に行っても原因不明</span>
                </li>
              </ul>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={handleReservation}
                className="w-full sm:w-auto bg-gold text-white px-8 py-4 rounded-full text-base md:text-lg font-semibold hover:bg-gold/90 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                波動測定を予約する
              </button>
              <button
                onClick={handleLineContact}
                className="w-full sm:w-auto bg-white text-gold border-2 border-gold px-8 py-4 rounded-full text-base md:text-lg font-semibold hover:bg-gold hover:text-white transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                LINEで相談する
              </button>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://media.toriaez.jp/r2315/5_m.JPG"
                alt="BODY REPORT 波動測定"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gold/20 to-transparent"></div>
            </div>
            
            {/* Floating Cards */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl p-4 md:p-6 max-w-[200px]">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center">
                  <i className="ri-time-line text-gold text-2xl"></i>
                </div>
                <div>
                  <p className="text-xs text-dark-gray/60">測定時間</p>
                  <p className="text-lg font-bold text-dark-gray">10〜15分</p>
                </div>
              </div>
            </div>

            <div className="absolute -top-6 -right-6 bg-white rounded-2xl shadow-xl p-4 md:p-6 max-w-[200px]">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center">
                  <i className="ri-heart-pulse-line text-gold text-2xl"></i>
                </div>
                <div>
                  <p className="text-xs text-dark-gray/60">測定箇所</p>
                  <p className="text-lg font-bold text-dark-gray">約800箇所</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Scroll Hint */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
          <i className="ri-arrow-down-line text-gold text-3xl"></i>
        </div>
      </div>
    </section>
  );
};

export default BodyReportHeroSection;
